import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {DeliveryOrderService} from 'app/blocks/service/api/delivery-order.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IDeliveryOrder} from 'app/blocks/model/delivery-order.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {DeliveryOrder} from 'app/blocks/model/delivery-order.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class DeliveryOrderResource extends AbstractEntityResource<IDeliveryOrder> {
    constructor(deliveryOrderService: DeliveryOrderService, router: Router) {
        super(
            Resource.DELIVERY_ORDERS,
            deliveryOrderService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.DELIVERY_ORDERS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.DELIVERY_ORDERS),
            (entity?) => new DeliveryOrder(entity),
            (entity) => entity.code
        );
    }
}
